import React from 'react';

const TONE_COLORS = {
  default: 'var(--color-ink)',
  good: 'var(--color-primary)',
  warning: 'var(--color-warning)',
  danger: 'var(--color-danger)',
};

/** label + big number + optional icon/subtext/progress bar. Color is used
 * sparingly — only on the number/icon, never as a full-card background. */
function StatCard({ label, value, icon: Icon, subtext, tone = 'default', progress }) {
  const toneColor = TONE_COLORS[tone] || TONE_COLORS.default;

  return (
    <div style={styles.card}>
      <div style={styles.top}>
        <p style={styles.label}>{label}</p>
        {Icon && (
          <div style={{ ...styles.iconWrap, color: toneColor }}>
            <Icon size={18} />
          </div>
        )}
      </div>
      <p style={{ ...styles.value, color: toneColor }}>{value}</p>
      {subtext && <p style={styles.subtext}>{subtext}</p>}
      {typeof progress === 'number' && (
        <div style={styles.progressTrack}>
          <div
            style={{
              ...styles.progressFill,
              width: `${Math.min(100, Math.max(0, progress))}%`,
              backgroundColor: toneColor,
            }}
          />
        </div>
      )}
    </div>
  );
}

const styles = {
  card: {
    backgroundColor: 'var(--color-surface)',
    border: '1px solid var(--color-border)',
    borderRadius: '12px',
    padding: '18px 20px',
    flex: '1 1 160px',
    minWidth: 0,
  },
  top: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '10px',
  },
  label: {
    fontSize: '13px',
    fontWeight: 600,
    color: 'var(--color-ink-soft)',
    margin: 0,
  },
  iconWrap: {
    display: 'flex',
  },
  value: {
    fontFamily: 'var(--font-display)',
    fontSize: '26px',
    fontWeight: 800,
    margin: '0 0 4px',
    fontVariantNumeric: 'tabular-nums',
  },
  subtext: {
    fontSize: '12px',
    color: 'var(--color-muted)',
    margin: 0,
  },
  progressTrack: {
    height: '4px',
    borderRadius: '999px',
    backgroundColor: 'var(--color-border)',
    overflow: 'hidden',
    marginTop: '10px',
  },
  progressFill: {
    height: '100%',
    borderRadius: '999px',
  },
};

export default StatCard;
